import TreeModel from 'tree-model';
import { add } from 'router/registry';
import { get } from 'templates';

/**
 * Parse the routes object creating a tree model
 * @param {object} routeData - application routes as object raw coming
 * @returns {TreeModel} object.tree - a new Tree Model instance
 * @returns {TreeModel} object.routes - the raw routes tree populated with the data we need to use for our application
 */
export function parse(routeData) {
    const tree = new TreeModel({
        childrenPropertyName: 'routes',
    }).parse(routeData);
    const routes = [];

    // walk through each route data node
    tree.walk(node => {
        const { model, parent } = node;
        // use the route fragments array to flatten the paths for the children nodes
        const fragments = parent ? [...parent.model.fragments, model.path] : [model.path];
        // get the real path concatenating all the previous url fragments
        const path = `/${ fragments.join('/') }/`;
        // extend the node model
        // that's actually not really nice because we extend pseudo immutable data
        node.model = { ...model, fragments };

        // add this model to the routes cloning it
        routes.push({
            ...model,
            component: get(model.template),
            name: model.name,
            path,
        });

        // add the route name to the registry if we need it
        if (model.name) {
            add(model.name, path, model.meta.menu_title || model.meta.title);
        }
    });

    return { tree, routes };
}





// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/router/parser.js